import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DateUtils, TypeUtils } from '@vectord/utils';
import range from 'lodash/range';

import generateTimeString from 'utils/generateTimeString';
import Select from 'components/Select';

function TimeInput({
  value,
  onChange,
  placeholder = 'Select time',
  step = DateUtils.ONE_MINUTE * 5,
  ...remainingProps
}) {
  const options = useMemo(() => {
    return range(0, DateUtils.ONE_DAY, step).map((o) => ({
      label: generateTimeString(o),
      value: o,
    }));
  }, [step]);

  const _value = useMemo(() => {
    if (TypeUtils.isNullOrUndefined(value)) return null;

    return {
      value,
      label: generateTimeString(value),
    };
  }, [value]);

  const handleChange = useCallback(
    (newValue) => {
      onChange(newValue.value);
    },
    [onChange]
  );

  return (
    <Select
      {...remainingProps}
      placeholder={placeholder}
      value={_value}
      options={options}
      onChange={handleChange}
    />
  );
}

TimeInput.propTypes = {
  // Pass time in milliseconds, will be parsed to HH:MM am/pm
  value: PropTypes.number,
  step: PropTypes.number,
  placeholder: PropTypes.string,
  // With the following def (timeInMs) => {}
  onChange: PropTypes.func,
};

export default TimeInput;
